import React, { useEffect, useState } from "react";
import { Row, Col, Form, Image, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Card from "../Card";

import { addUser, getUserList } from "../../services/Users-services";

import {
  addDepartment,
  getDepartmentDetails,
  updateDepartment,
} from "../../services/Users-services";
import {
  createClass,
  getClassDetails,
  updateClass,
  getTutorList,
} from "../../services/Academic-Services.js";
import {
  callToast,
  prepareSiteList,
  showErrorMessages,
} from "../../services/utilityFunctions.js";
import { useGlobalState } from "../../services/hostelConst";
import Select from "react-select";
import { getLocalStorageData } from "../../services/axiosComponent";
import { selectStyle } from "../../services/constant";
import { useSelector, useDispatch } from "react-redux";
import {
  openModal,
  closeModal,
} from "../../services/redux/reducers/modalSlice";
const AddClassesForm = ({ navigate, refresh }) => {
  const modal = useSelector((state) => state.modal);
  const dispatch = useDispatch();

  const [regionOptions, setRegionOptions] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isSiteOptionsLoading, setIsSiteOptionsLoading] = useState(false);
  const [siteOptions, setSiteOptions] = useState([]);
  const [tutatOptions, setTutatOptions] = useState([]);
  const [isTutarOptionLoading, setIsTutarOptionLoading] = useState(false);
  const [isSiteSearchable, setIsSiteSearchable] = useState(true);
  const [isRegionSearchable, setIsRegionSearchable] = useState(true);
  const prepareFormData = (data = null) => {
    return {
      name: data != null ? data.NAME : "",
      discription: data != null ? data.DESCRIPTION : "",
      siteId: {
        value: data != null ? data["_SITE"] : "",
        label: data != null ? data["SITE"] : "",
      },
      regionId: {
        value: data != null ? data["_REGION"] : "",
        label: data != null ? data["REGION"] : "",
      },
      tutarId: {
        value: data != null ? data["_tutor"] : "",
        label: data != null ? data["NAME"] : "",
      },
    };
  };
  const [loadingData, setLoadingData] = useState(modal.isEditing);
  const [formData, setFormData] = useState(prepareFormData());
  const getDepartmentDetailsData = async (departmentId) => {
    setLoadingData(true);
    var res = await getClassDetails(departmentId);
    if (res.status == "fail") {
      showErrorMessages({ data: res, navigate });
    } else {
      console.log(res, "get department details");
      setFormData(prepareFormData(res.data));
    }
    setLoadingData(false);
  };

  const handleChange = (field, value) => {
    setErrors({});
    if (field == "regionId") {
      setFormData((prev) => ({ ...prev, siteId: { value: "", label: "" } }));
      setFormData((prev) => ({
        ...prev,
        tutarId: { value: "", label: "" },
      }));
    }
    if (field == "siteId") {
      setFormData((prev) => ({
        ...prev,
        tutarId: { value: "", label: "" },
      }));
    }
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const validateFields = () => {
    let isValid = true;
    let errors = {};
    if (formData.name == "") {
      isValid = false;
      errors.name = "Class Name is required";
    }
    if (formData.discription == "") {
      isValid = false;
      errors.discription = "Discription is required";
    }
    if (formData.tutarId.value == "") {
      isValid = false;
      errors.tutarId = "Tutor  is required";
    }
    if (formData.regionId.value == "") {
      isValid = false;
      errors.region = "Region is required";
    }
    if (formData.siteId.value == "") {
      isValid = false;
      errors.site = "Site is required";
    }
    setErrors(errors);
    return isValid;
  };

  const handleSubmit = async () => {
    if (validateFields()) {
      setLoading(true);

      var submitData = {
        description: formData.discription,
        // tutorId: formData.tutarId.value,
        name: formData.name,
        organizationId:
          getLocalStorageData("profileDetails")["_ORGANIZATION_"]._ID,
        regionId: formData.regionId.value,
        siteId: formData.siteId.value,
        id: modal.isEditing ? modal.data._ID : null,
      };
      var res = modal.isEditing
        ? await updateClass(submitData)
        : await createClass(submitData);
      if (res.status == "success") {
        callToast(
          "success",
          modal.isEditing ? "Updated" : "Created",
          modal.isEditing
            ? "Classes updated successfullly"
            : "Classes added successfully"
        );

        await refresh({ columnRefresh: false, isLoading: false });
        setLoading(false);
        dispatch(closeModal());
      } else {
        setLoading(false);
        showErrorMessages({
          data: res,
          navigate,
        });
      }
    }
  };

  const getSiteList = async (regionId, query) => {
    setIsSiteOptionsLoading(true);
    var data = await JSON.parse(localStorage.getItem("profileDetails"));
    var list = await prepareSiteList(regionId, navigate, query);

    if (
      list.length == 1 &&
      list[0].value == data._SITE &&
      data["_SITE ACCESS_"] == null
    ) {
      setIsSiteSearchable(false);
      handleChange("siteInfo", "site", {
        value: list[0].value,
        label: list[0].label,
      });
    }

    setIsSiteOptionsLoading(false);
    if (list.length == 0) {
      setErrors((prev) => ({
        ...prev,
        site: "No site available for this region",
      }));
    } else {
      setErrors((prev) => ({
        ...prev,
        site: "",
      }));
    }
    setSiteOptions(list);
  };

  const getRegionList = async () => {
    var data = await JSON.parse(localStorage.getItem("profileDetails"));
    var list = JSON.parse(localStorage.getItem("regionList"));
    if (
      list.length == 1 &&
      list[0].value == data._REGION &&
      data["_REGION_ACCESS_"] == null
    ) {
      setIsRegionSearchable(false);
      handleChange("siteInfo", "region", {
        value: list[0].value,
        label: list[0].label,
      });
    }
    setRegionOptions(list);
  };

  const getTutorOptionsList = async (siteId) => {
    setIsTutarOptionLoading(true);
    var res = await getTutorList({
      regionId: formData.regionId.value,
      siteId: siteId,
      status: "Y",
    });
    if (res.status == "fail") {
      showErrorMessages({ data: res, navigate });
    } else {
      var list = [];
      res.data.entityList.map((item) => {
        list.push({
          value: item._ID,
          label: item["NAME"],
        });
      });
      setIsTutarOptionLoading(false);
      setTutatOptions(list);
    }
  };

  useEffect(() => {
    getRegionList();
    if (modal.isEditing == true) {
      getDepartmentDetailsData(modal.data._ID);
    }

    return () => {};
  }, []);

  return (
    <>
      {loadingData ? (
        <center>
          <div class="spinner-border text-primary" role="status">
     
          </div>
        </center>
      ) : (
        <section className="login-content">
          <div className="">
            {/* <div
            className="position-absolute top-10 start-20 bg-primary"
            style={{
              left: "5%",
              top: "-10%",
              width: "12%",
              height: "120%",
              backgroundColor: "blue",
            }}
          ></div> */}

            <div className="d-flex">
              <div className="w-100 ps-5 pe-5">
                <form>
                  <>
                    <div className="mb-3">
                      <div className="form-row ">
                        <div class="col">
                          <label className="form-label">Class Name</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter  Name"
                            value={formData.name}
                            onChange={(e) =>
                              handleChange("name", e.target.value)
                            }
                          />
                          {errors.name && (
                            <small className="text-danger">{errors.name}</small>
                          )}
                        </div>
                        <div class="col mt-3">
                          <label className="form-label">Discription </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Discription"
                            value={formData.discription}
                            onChange={(e) =>
                              handleChange("discription", e.target.value)
                            }
                          />
                          {errors.discription && (
                            <small className="text-danger">
                              {errors.discription}
                            </small>
                          )}
                        </div>
                      </div>
                    </div>{" "}
                    <div className="mb-3 ">
                      <label className="form-label">Region </label>

                      <Select
                        styles={selectStyle}
                        options={regionOptions}
                        value={
                          formData.regionId.label == ""
                            ? null
                            : formData.regionId
                        }
                        onChange={(newValue) => {
                          handleChange(
                            "regionId",
                            newValue == null
                              ? { value: "", label: "" }
                              : newValue
                          );

                          if (newValue != null) {
                            getSiteList(newValue.value);
                          }
                        }}
                        onInputChange={(inputValue, { action }) => {}}
                        noOptionsMessage={() => {
                          return !isRegionSearchable
                            ? "Region Access not available"
                            : "No matches found";
                        }}
                        isSearchable={isRegionSearchable}
                        placeholder="Select Region "
                        className="basic-single"
                        classNamePrefix="select"
                        filterOption={(option, inputValue) =>
                          option.label
                            .toLowerCase()
                            .includes(inputValue.toLowerCase())
                        }
                      />
                      {errors.region && (
                        <small className="text-danger">{errors.region}</small>
                      )}
                    </div>
                    <div className="mb-3 ">
                      <label className="form-label">Site</label>

                      <Select
                        styles={selectStyle}
                        options={siteOptions}
                        value={
                          formData.siteId.label == "" ? null : formData.siteId
                        }
                        components={
                          isSiteOptionsLoading
                            ? {
                                DropdownIndicator,
                              }
                            : null
                        }
                        onChange={(newValue) => {
                          handleChange(
                            "siteId",
                            newValue == null
                              ? { value: "", label: "" }
                              : newValue
                          );

                          getTutorOptionsList(newValue.value);
                        }}
                        onInputChange={(inputValue, { action }) => {
                          getSiteList(formData.regionId.value, inputValue);
                        }}
                        noOptionsMessage={() => {
                          return !isSiteSearchable
                            ? "Site Access Not available"
                            : "No matches found";
                        }}
                        isSearchable={isSiteSearchable}
                        placeholder="Select Site "
                        className="basic-single"
                        classNamePrefix="select"
                        filterOption={(option, inputValue) =>
                          option.label
                            .toLowerCase()
                            .includes(inputValue.toLowerCase())
                        }
                      />
                      {errors.site && (
                        <small className="text-danger">{errors.site}</small>
                      )}
                    </div>
                    <div className="mb-3 ">
                      <label className="form-label">Tutor </label>

                      <Select
                        styles={selectStyle}
                        options={tutatOptions}
                        value={
                          formData.tutarId.label == "" ? null : formData.tutarId
                        }
                        components={
                          isTutarOptionLoading
                            ? {
                                DropdownIndicator,
                              }
                            : null
                        }
                        onChange={(newValue) => {
                          handleChange(
                            "tutarId",
                            newValue == null
                              ? { value: "", label: "" }
                              : newValue
                          );
                        }}
                        onInputChange={(inputValue, { action }) => {
                          if (action === "input-change") {
                          }
                        }}
                        noOptionsMessage={() => {
                          return "No  Tutor  available";
                        }}
                        isSearchable={true}
                        placeholder="Select Tutor Head"
                        className="basic-single"
                        classNamePrefix="select"
                        filterOption={(option, inputValue) =>
                          option.label
                            .toLowerCase()
                            .includes(inputValue.toLowerCase())
                        }
                      />
                      {errors.tutarId && (
                        <small className="text-danger">{errors.tutarId}</small>
                      )}
                    </div>
                  </>

                  <div className="d-flex justify-content-end mt-4 gap-2">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleSubmit}
                      disabled={loading}
                    >
                      {loading ? (
                        <div
                          className="spinner-border text-light"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};
const DropdownIndicator = (props) => {
  return (
    <div {...props.innerProps}>
      <div
        class="spinner-border text-primary spinner-border-sm m-2"
        role="status"
      >
 
      </div>
    </div>
  );
};

export default AddClassesForm;
